module.exports = __webpack_public_path__ + "static/media/arrow.4806e288.svg";